import { garantia } from '../../apiClient/index'

function initialState () {
  return {
    filtrosGarantia: undefined
  }
}

const moduloGarantias = {
  namespaced: true,
  state: initialState,
  actions: {
    altaGarantia(context, payload) {
      // propago los errores HTTP para que el componente los muestre y libere el estado de carga
      return garantia.post('/api/Garantias/AltaGarantia', payload)
        .then(response => response.data)
    },

    getConfiguracionImagenes() {
      return garantia.get('/api/Garantias/ConfiguracionImagenesRegistroGarantias')
        .then(response => response.data)
    },

    getGarantias(context, payload) {
      context.commit('setFiltrosGarantia', payload)

      // busco las garantías
      return new Promise((resolve) => {
        garantia.get('/api/Garantias/FindGarantiasPaginated', { params: payload })
        .then(response => resolve(response.data))
      })
    },

    getGarantiasAVencer(context, payload) {
      context.commit('setFiltrosGarantia', payload)

      return garantia.get('/api/Garantias/FindGarantiasProximasAAvencer', {params: payload})
        .then(response => response.data)
    },

    exportarGarantiasVencidas(context, payload) {
      return new Promise((resolve)=> {
        garantia.get('/api/Garantias/Export', 
        {
          params: payload, 
          responseType:'arraybuffer' 
        })
        .then(response => {
          
          // genero un blob con la respuesta
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
  
          // descargo el archivo
          if (navigator.msSaveOrOpenBlob) 
          {
              navigator.msSaveBlob(blob, 'file.xlsx');
          } 
          else 
          {
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.download = 'Garantías próximas a vencer.xlsx';
              link.click();
              document.body.removeChild(link);
          }
        })
        .finally(() => resolve())
      })
    },

    setFiltrosGarantia(context, payload) {
      // guardo los filtros aplicados
      context.commit('setFiltrosGarantia', payload)
    },

    uploadImagen(context, payload) {      
      // armo el payload
      let formData = new FormData()
      formData.append('imagen', payload.file)

      // subo el archivo
      return new Promise((resolve, reject) => {
        garantia.post('/api/Garantias/UploadImagenRegistroGarantias', formData, {
          params: { nombre: payload.id, numeroArchivo: payload.numeroArchivo, ns: payload.ns },
          // si la subida queda colgada se informa como error y no se habilita el guardado
          timeout: 120000
        })
        .then(
          response => { resolve(response.data) },
          error => { reject(error) }
        )
      })
    },
  },
  mutations: {
    setFiltrosGarantia(state, payload) {
      state.filtrosGarantia = payload
    }
  }
}

export default moduloGarantias